<template>
  <admin-page-shell :title="$t('frontend_groovemail_tracking_domains_route_page_title')">
    <server-table
      class="text-center groovemail-tracking-domains-table"
      ref="serverTable"
      :url="trackingDomainsListingUrl"
      tableRef="trackingDomainsTable"
      tableTitle="frontend_groovemail_tracking_domains_route_page_title"
      :slotData="trackingDomainSlotData"
      :tableColumns="trackingDomainsTableColumns"
      :tableOptions="trackingDomainsTableOptions"
      addNewBtnText="frontend_groovemail_new_tracking_domains"
      firstFilterName="frontend_groovemail_smtp_select_pool_level"
      :firstSelectedFilter="poolFilterType"
      :firstFilterData="poolData"
      @addNewData="addTrackingDomain"
      @firstFilterUpdated="poolFilterUpdated"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>

    <gs-named-modal
      id="tracking-domains-modal"
      name="tracking-domains-modal"
      :title="modalTitle"
      @closed="trackingDataInitialized()"
    >
      <div class="gm-admin-modal__body">
        <gs-field :label="$t('frontend_groovemail_smtp_pool_level')">
          <select v-model="model.poolType">
            <option value="">
              {{ $t('frontend_groovemail_smtp_select_pool_level') }}
            </option>
            <option
              v-for="poolData in this.poolData"
              :key="poolData.id"
              :value="poolData.id"
            >
              {{ poolData.name }}
            </option>
          </select>
          <p
            class="gm-admin-tab__error"
            v-if="this.formSubmitted && !model.poolType"
          >
            {{ $t('frontend_groovemail_smtp_select_pool_level_required') }}
          </p>
        </gs-field>
        <gs-field :label="$t('frontend_groovemail_tracking_domains_route_page_title')">
          <text-area
            v-if="addModal"
            variant="base"
            v-model="model.domains"
            :placeholder="this.$t('frontend_groovemail_enter_new_tracking_domains')"
            rows="5"
          />
          <text-input
            v-else
            variant="base"
            v-model="model.domains"
            :placeholder="this.$t('frontend_groovemail_enter_new_tracking_domains')"
            :validator="$v.model.domains"
          />
        </gs-field>
        <p class="gm-admin-tab__note" v-if="addModal">
          <span class="fa fa-info-circle"></span>
          {{ $t('frontend_groovemail_enter_new_tracking_domains_note') }}
        </p>
        <div class="gm-admin-modal__footer">
          <gs-button variant="outline" @click="closeTrackingDomain()">{{ $t('frontend_cancel') }}</gs-button>
          <gs-button
            variant="primary"
            @click="addModal ? addTrackingDomains() : updateTrackingDomains()"
          >
            {{ addModal ? $t('frontend_save') : $t('frontend_update') }}
          </gs-button>
        </div>
      </div>
    </gs-named-modal>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-remove-tracking`"
      :name="`confirmation-remove-tracking`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_are_you_sure_delete_tracking_domains')"
      @confirm="removeTrackingDomains"
      @close="closRremoveTrackingModal"
    />
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import monthsMixin from '@/mixin/monthsMixin.js';
import {showRequestErrorAlert} from '@/components/showDialog.js';
import { adminUrls } from '@/utils/urls.js';
import { getData, postData, deleteData, putData } from '@/utils/apiHelper.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',
  mixins: [demoModeValuesMixin, monthsMixin],
  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_tracking_domains_route_page_title'),
    };
  },
  
  data() {
    return {
      modalType: 'add',
      trackingDomainsListingUrl: adminUrls.trackingDomainUrl.trackingDomain,
      model: {
        domains: '',
        poolType: '',
      },
      confirmId: null,
      currentTrackingDomain: '',
      poolData: [],
      trackingDomains: [],
      formSubmitted: false,
      poolFilterType: '',
      trackingDomainsTableColumns: [
        'domain_url',
        'pool_type_id',
        'created_at',
        'actions',
      ],
      trackingDomainsTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        customFilters: ['pool_filter_id'],
        headings: {
          domain_url: () =>
            this.$t('frontend_groovemail_tracking_domains_listing_header'),
          pool_type_id: () => this.$t('frontend_groovemail_smtp_pool_level'),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['domain_url', 'pool_type_id'],
        sortable: ['domain_url', 'pool_type_id', 'created_at'],
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              domain_url: self.basicDomainText
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },
    };
  },

  validations: {
    model: {
      domains: {
        required,
      },
    },
  },
  components: {
    AdminPageShell,
    ServerTable
  },

  watch: {
    // Used to refresh tracking domains table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.trackingDomainsTable.refresh();
    },
  },

  computed: {
    // Returns true if modalType is add.
    addModal() {
      return this.modalType === 'add';
    },

    // Returns modal title based on modal type
    modalTitle() {
      return this.addModal
        ? this.$t('frontend_groovemail_add_new_tracking_domains')
        : this.$t('frontend_groovemail_edit_tracking_domain');
    },

    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    /**
     *  Returns slot data for tracking domain table.
     *  @return {array} details for slot columns for tracking domain table.
     */
    trackingDomainSlotData() {
      return [
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_edit'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.editTrackingDomains(props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_delete'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openRemoveTrackingModal(props.row.id),
            },
          ],
        },
      ];
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },
    /**
     * Sets custom filter value & refreshes table after applying filter.
     * @param {object} event object which contains updated pool fiter type id.
     */
    poolFilterUpdated(event) {
      this.poolFilterType = event;

      if (event) {
        this.$refs.serverTable.$refs.trackingDomainsTable.customQueries.pool_filter_id = event;
      } else {
        this.$refs.serverTable.$refs.trackingDomainsTable.customQueries.pool_filter_id = '';
      }
      this.$refs.serverTable.$refs.trackingDomainsTable.refresh();
    },

    // Fetches pool types
    async fetchPoolTypes() {
      const poolData = await getData(adminUrls.smtpUrl.smtpPoolTypes);
      
      const data = poolData && poolData.data;

      // stop if no data is present
      if(data.length === 0) {
        return;
      }

      // set pool data to data properties
      data.forEach((element) => {
        this.poolData.push({ text: element.name, value: element.id});
      });

      // if (poolData && poolData.data) {
      //   this.poolData = poolData.data.filter((ele) => {
      //     return ele.short_name !== 'internal_app';
      //   });
      // }
    },

    // Used to open add tracking domains modal.
    async addTrackingDomain() {
      this.modalType = 'add';
      await this.fetchPoolTypes();
      this.$root.$emit('modal-open', 'tracking-domains-modal');
    },

    // Used to close add tracking domains modal.
    closeTrackingDomain() {
      this.$root.$emit('modal-close', 'tracking-domains-modal');
    },

    /**
     * Used to open edit tracking domains modal.
     * @param {string} domainId unique id of a domain.
     */
    async editTrackingDomains(domainId) {
      this.modalType = 'edit';
      this.currentTrackingDomain = domainId;
      await this.fetchPoolTypes();
      const domainData = await getData(
        `${adminUrls.trackingDomainUrl.trackingDomain}/${domainId}`
      );
      this.model.poolType = domainData?.data?.pool_type_id;
      this.model.domains = domainData?.data?.domain_url;
      this.$root.$emit('modal-open', 'tracking-domains-modal');
    },
    
    // Used to save tracking domain details.
    async addTrackingDomains() {
      this.formSubmitted = true;
      if (this.model.domains.trim() && this.model.poolType) {
        const trackingDomainsData = this.model.domains.trim();
        const splitted = trackingDomainsData.split('\n');
        splitted.forEach((element) => {
          if (element.trim()) {
            this.trackingDomains.push(element.trim());
          }
        });
        const addDomainRes = await postData(adminUrls.trackingDomainUrl.trackingDomain, {
          track_domains: this.trackingDomains,
          pool_type_id: this.model.poolType,
        });
        if (addDomainRes && addDomainRes.data && addDomainRes.data.error) {
          await showRequestErrorAlert(this.$t('frontend_groovemail_admin_tracking_domain_add_valid_domain'));
        } else {
          this.$refs.serverTable.$refs.trackingDomainsTable.refresh();
          this.$root.$emit('modal-close', 'tracking-domains-modal');
        }
      }
    },

    // Used to resets tracking domain data
    trackingDataInitialized() {
      this.trackingDomains = [];
      this.model.domains = '';
      this.model.poolType = '';
      this.$v.model.domains.$reset();
      this.formSubmitted = false;
    },


    // open Remove Tracking domain modal
    async openRemoveTrackingModal(id) {
      // set the Confirm id
      this.confirmId = id;

      // open the modal
      this.$refs[`confirmation-remove-tracking`].open();
    },

    // close Remove Tracking domain modal
    closRremoveTrackingModal() {
      // reset the Confirm id
      this.confirmId = null;
    },

    // Used to remove tracking domains.
    async removeTrackingDomains() {
      try {
        await deleteData(`${adminUrls.trackingDomainUrl.trackingDomain}/${this.confirmId}`);
        
        const domainsData = await getData(
          `${adminUrls.trackingDomainUrl.trackingDomain}?query=${this.$refs.serverTable.$refs.trackingDomainsTable.filteredQuery}&limit=${this.trackingDomainsTableOptions.perPage}&page=${this.$refs.serverTable.$refs.trackingDomainsTable.Page}&ascending=1&byColumn=0`
        );
        this.$refs.serverTable.updateData(domainsData?.data[0]?.data, domainsData?.data[0]?.total);

      } catch (error) {
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // Used to update tracking domain details.
    async updateTrackingDomains() {
      this.formSubmitted = true;
      this.$v.model.domains.$touch();
      if (!this.$v.model.domains.$invalid && this.model.poolType) {
        try {
          await putData(`${adminUrls.trackingDomainUrl.trackingDomain}/${this.currentTrackingDomain}`, {
              domain_url: this.model.domains.trim(),
              pool_type_id: this.model.poolType,
            }
          );
          this.$refs.serverTable.$refs.trackingDomainsTable.refresh();
          this.$root.$emit('modal-close', 'tracking-domains-modal');

        } catch (error) {
          showRequestErrorAlert(error?.response?.data?.error);
        }
      }
    },
  },

  // Fetches pool types when page loads
  async created() {
    self = this;
    await this.fetchPoolTypes();
  },
};
</script>
